"use strict";

(function(){
    /**
     * Работа с макетом страниц
     */
    var self = Fotobook.pageLayout = {

        /**
         * Диалог изменения фото на обложке
         *
         * @param id
         */
        changeCoverLayoutDialog: function(id) {
            self.changeDialog({
                "title"         : t("photobook-js-applyCoverLayoutDialogTitle"),
                "content"       : t("photobook-js-applyCoverLayout"),
                "all_condition" : ".cover",
                "no_all"        : true,
                "both_text"     : t("photobook-js-captionBothCovers").capitalize(),
                "left_text"     : t("photobook-js-captionBackCover").capitalize(),
                "right_text"    : t("photobook-js-captionFrontCover").capitalize(),
            }).then((data) => {
                self.selectCoverLayout(id, data.pages);
            }).catch(
                () => {}
            );
        },

        /**
         * Изменеие макета фото на обложке
         *
         * @param id
         * @param $pages
         */
        selectCoverLayout: function(id, $pages){
            $pages = Fotobook.filterEmptyPages($pages);
            if (!$pages.length || $pages.filter(":not(.cover)").length) {
                Fotobook.notification.showWarning(t("photobook-js-messageCoverLayoutForCovers"));
                return;
            }
            const map = $pages.toArray().reduce((data, page) => {
                data[page.getAttribute('data-id')] = id;
                return data;
            }, {});
            self.changePageLayoutRequest(map);
        },

        /**
         * Диалог изменения макета страницы
         *
         * @param id
         */
        changePageLayoutDialog: function (id) {
            self.changeDialog({
                "title": t("photobook-js-applyElementDialogTitle", {"element": t("photobook-js-layout")}),
                "content": t("photobook-js-applyElement", {"elementName": t("photobook-js-layout")}),
                "all_condition": ".page",
            }).then((data) => {
                self.selectPageLayout(id, data.pages);
            }).catch(
                () => {}
            );
        },

        /**
         * Изменеие макета страницы
         *
         * @param id
         * @param $pages
         */
        selectPageLayout: function (id, $pages) {
            $pages = Fotobook.filterEmptyPages($pages);
            if (!Fotobook.checkValidPage($pages)) {
                return;
            }
            const map = $pages.toArray().reduce((data, page) => {
                data[page.getAttribute('data-id')] = id;
                return data;
            }, {});
            self.changePageLayoutRequest(map);
        },

        /**
         * Показать диалог выбора страниц(ы)
         *
         * @param data
         * @returns {*}
         */
        changeDialog: function(data){
            return new Promise((resolve) => {
                let buttons = [],
                    fotobookButtonClass = 'fotobook_button functional-button',
                    $current_pages = $(Fotobook.book.book).find(".pages-wrapper").find(".book-page"),
                    $pages = $current_pages.filter(data.all_condition || ""),
                    $left = $pages.filter(".left"),
                    $right = $pages.filter(".right");

                if ($current_pages.length === 1) {
                    let singleBtnText;
                    if ($left.length) {
                        singleBtnText = data.left_text;
                    } else if ($right.length) {
                        singleBtnText = data.right_text;
                    } else {
                        singleBtnText = t("photobook-js-buttonsCurrentPage");
                    }

                    buttons.push({
                        "text": singleBtnText,
                        "class": fotobookButtonClass + (!$pages.length ? "disabled" : ""),
                        "click": function(e){
                            if (e && e.currentTarget && !$(e.currentTarget).hasClass("disabled")) {
                                $(this).dialog("close");
                                resolve({
                                    "pages" : $current_pages,
                                    "button" : "current",
                                });
                            }
                        }
                    });
                } else {
                    buttons.push({
                        "text": data.left_text || t("photobook-js-buttonsLeftPage"),
                        "class": fotobookButtonClass + (!$left.length ? "disabled" : ""),
                        "click": function(e){
                            if (e && e.currentTarget && !$(e.currentTarget).hasClass("disabled")) {
                                $(this).dialog("close");
                                resolve({
                                    "pages" : $current_pages.filter(".left"),
                                    "button" : "left",
                                });
                            }
                        }
                    });
                    buttons.push({
                        "text": data.right_text || t("photobook-js-buttonsRightPage"),
                        "class": fotobookButtonClass + (!$right.length ? "disabled" : ""),
                        "click": function(e){
                            if (e && e.currentTarget && !$(e.currentTarget).hasClass("disabled")) {
                                $(this).dialog("close");
                                resolve({
                                    "pages" : $current_pages.filter(".right"),
                                    "button" : "right",
                                });
                            }
                        }
                    });
                    if (!data.no_both)
                        buttons.push({
                            "text": data.both_text || t("photobook-js-buttonsBothPages"),
                            "class": fotobookButtonClass + ($pages.length === 2 ? "" : "disabled"),
                            "click": function(e){
                                if (e && e.currentTarget && !$(e.currentTarget).hasClass("disabled")) {
                                    $(this).dialog("close");
                                    resolve({
                                        "pages" : $current_pages,
                                        "button" : "both",
                                    });
                                }
                            }
                        });
                }
                if (!data.no_all) {
                    buttons.push({
                        "class": fotobookButtonClass,
                        "text": data.all_text || t("photobook-js-buttonsAllPages"),
                        "click": function (e) {
                            if (e && e.currentTarget && !$(e.currentTarget).hasClass("disabled")) {
                                $(this).dialog("close");
                                resolve({
                                    "pages" : $(Fotobook.book.pagesList).find(".book-page").filter(data.all_condition),
                                    "button" : "all",
                                });
                            }
                        },
                    });
                }

                Fotobook.dialog.html(data.content, {
                    "title": data.title,
                    "dialogClass": "fotobook-dialog editor buttons-center autotest-replace-layout-dialog",
                    "zIndex": 500,
                    "buttons": buttons,
                    "open": function(){
                        $(this)
                            .css("minWidth", "300px")
                            .find(':button').blur();
                    },

                });
            });
        },

        /**
         * Запрос на изменения лейаута страницы
         */
        changePageLayoutRequest(map) {
            return Fotobook.ajax.postJSON('/editor/page/select-layout', {
                data: {
                    map,
                },
            }).then((response) => {
                $(document).triggerHandler(Fotobook.events.MODIFIED, response);
            }).catch(() => null);
        },
    };

})();
